import { useMemo } from 'react';

import { ROLE_NAME } from '@constants/permissions.constants';
import { GetAllRolesQuery_getAllRoles as Roles } from '@generated/GetAllRolesQuery';
import { GetUserQuery, GetUserQueryVariables } from '@generated/GetUserQuery';
import { GET_USER_QUERY } from '@graphql/queries/GetUserQuery';
import { useCompanyRoles } from '@hooks/useCompanyRoles/useCompanyRoles';
import { useGraphQuery } from '@hooks/useQuery';
import merge from 'lodash-es/merge';

export const useComputeRolesInitialFormValues = (id?: string): Roles[] => {
  const { companyRoles } = useCompanyRoles();

  const { data } = useGraphQuery<GetUserQuery, GetUserQueryVariables>(GET_USER_QUERY, {
    variables: {
      agentID: id!,
    },
    skip: !id,
  });
  const agentRole = useMemo(
    () => companyRoles.find((item) => item.name === ROLE_NAME.AGENT),
    [companyRoles]
  );

  return merge([agentRole], data?.getAgentV2?.roles || []);
};
